<template>
  <div>
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :title="`Usuários Liderados por ${liderados.name}`"
      :loading="disable"
      :columns="columns"
      v-model:pagination="pagination"
      class="q-mt-xl tabela-tamanho-fixo"
      row-key="name"
      dense
      hide-pagination
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-remover="props">
        <q-td>
          <q-btn
            flat
            no-caps
            color="red"
            icon="sym_o_delete"
            @click="(confirmacao = true), (saveId = props.row)"
          >
            <q-tooltip anchor="bottom right" self="top middle">
              Remover
            </q-tooltip>
          </q-btn>
        </q-td>
      </template>
    </q-table>

    <dialog-confirm-design
      mensagem="Tem certeza que deseja excluir o usuário?"
      :exibir="confirmacao"
      @resultado="excluirUsuario"
    />

    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    field: "email",
    align: "left",
  },

  {
    name: "sap",
    label: "ID Usuário",
    field: "sap",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";
export default {
  components: { DialogConfirmDesign },
  props: ["filtros", "unidades", "liderados"],
  setup(props, context) {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const unidade = ref("");
    const filtrar = ref("");
    const confirmacao = ref(false);
    const saveId = ref(null);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 100,
      rowsNumber: 15,
    });
    const getDados = async () => {
      disable.value = true;
      try {
        rows.value = props.liderados.liderados;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const excluirUsuario = async (resutado) => {
      confirmacao.value = false;
      if (resutado) {
        disable.value = true;
        try {
          await store.dispatch("user/desvincularLider", {
            id: saveId.value.id,
          });

          rows.value = rows.value.filter((user) => user.id !== saveId.value.id);

          context.emit("atualizarDados");

          quasar.notify({
            message: "Usuário excluído com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          disable.value = false;
          quasar.notify({
            message: "Erro ao excluir usuário",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => props.liderados,
      () => {
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {}
    );

    watch(
      () => props.unidades,
      () => {}
    );
    return {
      rows,
      columns,
      getDados,
      unidade,
      pagination,
      handleRequest,
      excluirUsuario,
      confirmacao,
      saveId,
      disable,
      filtrar,

      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style></style>
